import toastr from 'toastr'

toastr.options.showEasing = 'swing'
toastr.options.hideEasing = 'linear'
toastr.options.closeEasing = 'linear'
toastr.options.progressBar = true
toastr.options.positionClass = 'toast-bottom-right'

export default toastr



// WEBPACK FOOTER //
// ./src/utils/toastr.js